import { FetchProps } from '@e3dc-react/shell/Hooks/AuthFetch/AuthFetch'
import { AxiosResponse } from 'axios'
import { ForecastPowerResponse } from 'src/Types/responses/storages/serialnumber/forecast/power'
import { Breakthrough as BreakthroughModel } from '../../../Types/responses/storages/serialnumber/forecast/breakthrough'

const TIME_STAMPS = 24 * 4
const MAX_DAYS = 32
const LIMIT = MAX_DAYS * TIME_STAMPS

/**
 * Fetches breakthrough data for the given time range
 * @param storageId string - serialnumber of the storage
 * @param from number - from when - date in unix-timestamp
 * @param to number - to when -date in unix-timestamp
 * @param authFetch auth-function with FetchProps
 * @param signal optional Abortsignal for the controller
 * @returns Array of Breakthrough-Data
 */
export const fetchBreakthrough = (
  storageId: string,
  from: number,
  to: number,
  authFetch: <T>(props: FetchProps) => Promise<AxiosResponse<T>>,
  signal?: AbortSignal
): Promise<BreakthroughModel[]> => {
  return authFetch({
    path: `weather-forecast/pv/${storageId}/breakthrough`,
    method: 'GET',
    endpoint: process.env.REACT_APP_WEATHER_API_ENDPOINT,
    payload: {
      time_min: from,
      time_max: to,
    },
    abortSignal: signal,
  })
    .then(r => r.data)
    .catch(err => []) as Promise<BreakthroughModel[]>
}

/**
 * Fetches PV-Forecast data for the given time range
 * @param storageId string - serialnumber of the storage
 * @param from number - from when - date in unix-timestamp
 * @param to number - to when -date in unix-timestamp
 * @param authFetch auth-function with FetchProps
 * @param signal optional Abortsignal for the controller
 * @returns Array of Forecast-Power-Data
 */
export const fetchForecast = (
  storageId: string,
  from: number,
  to: number,
  authFetch: <T>(props: FetchProps) => Promise<AxiosResponse<T>>,
  signal?: AbortSignal
): Promise<ForecastPowerResponse[]> => {
  return authFetch({
    path: `weather-forecast/pv/${storageId}/power`,
    method: 'GET',
    endpoint: process.env.REACT_APP_WEATHER_API_ENDPOINT,
    payload: {
      time_min: from,
      time_max: to,
      limit: LIMIT,
      sort: '+time',
    },
    abortSignal: signal,
  })
    .then(r => r.data)
    .catch(err => []) as Promise<ForecastPowerResponse[]>
}
